import React, { FC } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { BarchartObject } from '../charts/interfaces';
import { exportDataAsCSV } from '../../util';
import { useSnackbar } from '@Iot-Bee/standard-web-library';

interface ExportIconProps {
  data: BarchartObject | null;
  selectedDevices: string[];
  workingHoursRange: [number, number];
}

const ExportIcon: FC<ExportIconProps> = ({ data, selectedDevices, workingHoursRange }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const {
    actions: { openSnackbar },
  } = useSnackbar();

  const handleExportClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };

  const handleExportCSV = () => {
    if (data === null) {
      openSnackbar('error', 'No data available!');
    } else {
      exportDataAsCSV(data, selectedDevices, workingHoursRange, 'kwh-consumption.csv');
    }

    handleExportClose();
  };

  return (
    <>
      <Button
        sx={{
          color: '#140C47',
          marginRight: '10px',
          fontSize: '30px',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'rgba(12, 92, 248, 0.1)',
            borderRadius: '10%',
          },
        }}
        onClick={handleExportClick}
      >
        <SystemUpdateAltIcon />
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleExportClose}>
        <MenuItem onClick={() => handleExportCSV()}>Export as CSV</MenuItem>
      </Menu>
    </>
  );
};

export default ExportIcon;
